import React from 'react'
import chart1 from '../chart1.png';
import chart2 from '../chart2.png';

function Chart({ chart }: { chart?: string }) {
    return (
        <>
            {
                chart === 'chart1' ? <img src={chart1} alt="chart1" style={{ objectFit: 'contain', height: '100%', margin: '0 auto' }} /> : <img src={chart2} alt="chart2" style={{ objectFit: 'contain', height: '100%', margin: '0 auto' }} />
            }
        </>
    )
}

export default Chart;